import styled from 'styled-components';

export const ScoringTypeBlock = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;

export const TopContentItem = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;

export const RankBlock = styled.div`
  margin: 0.5rem 0;
  display: flex;
  flex: 1;
  align-items: center;
`;

export const RankNum = styled.div`
  width: 30px;
  display: flex;
  justify-content: flex-end;
  font-size: 1.5rem;
`;

export const RankPlayer = styled.div`
  border: 1px solid lightgray;
  margin-left: 1rem;
  padding: 0.5rem 1rem;
  width: 360px;
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;

export const ActionBtnContainer = styled.div`
  display: flex;
`;
